import './styles.scss';

function Cover() {

    return (
        <div className="container-cover" >
            <div className="cover-text">

                <div>
                    <h1>Cuidar das suas pernas<br></br>é cuidar da sua liberdade.</h1>
                    <p>Tratamentos modernos, seguros e personalizados para varizes e vasinhos — com escuta, acolhimento e resultados reais.</p>
                    <a href="https://wa.me/5571997303062" target="_blank" rel="noopener noreferrer">Quero agendar minha consulta</a>

                </div>
                <div>

                    <div className='cover-footer'>
                        <span>CRM 34812 / RQE 25366 </span>
                        <span>Angiologista e Cirurgiã Vascular – Dra. Lais Muhana</span>
                        <span> Atendimentos em Salvador – BA</span>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Cover;
